export enum BlStatusEnum {
    NOT_RECEIVED = 'NOT RECEIVED',
    DRAFT_RECEIVED = 'DRAFT RECEIVED',
    OBL_RECEIVED = 'OBL RECEIVED',
    RECEIVED_AND_SHARED = 'RECEIVED AND SHARED',
}